/* MBD — Horizon integration: the page scrolls inside .page-wrapper, not window */
(function () {
  'use strict';
  var M = window.MBD || {};
  var pw = document.querySelector('.page-wrapper');
  M.scroller = pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) ? pw : null;
  var header = document.querySelector('[data-mbd-header]');
  if (M.scroller && header) {
    var ticking = false;
    M.scroller.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { header.classList.toggle('is-scrolled', M.scroller.scrollTop > 60); ticking = false; });
    }, { passive: true });
  }
  var locked = false;
  new MutationObserver(function () {
    var now = document.body.classList.contains('mbd-lock');
    if (now === locked) return;
    locked = now;
    if (now) document.documentElement.setAttribute('scroll-lock', '');
    else document.documentElement.removeAttribute('scroll-lock');
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* header cart total: wrap the total text so it can be refreshed after AJAX cart changes */
  document.querySelectorAll('.mbd-header .mbd-hicon .mbd-hicon__label').forEach(function (lab) {
    var last = lab.lastChild;
    if (last && last.nodeType === 3 && /\d/.test(last.textContent)) {
      var s = document.createElement('span'); s.setAttribute('data-mbd-cart-total', ''); s.textContent = last.textContent.trim();
      lab.replaceChild(s, last);
    }
  });
  var orig = M.setCartCount;
  if (orig) M.setCartCount = function (n) {
    orig(n);
    if (M.__totalBusy) return;
    M.__totalBusy = true;
    fetch(M.root() + '/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-mbd-cart-total]').forEach(function (el) { el.textContent = M.formatMoney(c.total_price); });
    }).catch(function () {}).finally(function () { M.__totalBusy = false; });
  };
})();